import { useState } from "react";
import { useT } from "../i18n";
import { tg } from "../telegram";
import { getTheme, toggleTheme, type Theme } from "../theme";

/**
 * Compact light/dark toggle pinned to the top corner, next to the language
 * picker. Shows the icon of the theme you'd switch TO. Persisted in theme.ts.
 */
export default function ThemeSwitcher() {
  const { t } = useT();
  const [theme, setTheme] = useState<Theme>(() => getTheme());

  const onClick = () => {
    tg()?.HapticFeedback?.impactOccurred("light");
    setTheme(toggleTheme());
  };

  const goingDark = theme === "light";
  return (
    <div className="theme-corner">
      <button
        type="button"
        className="theme-corner-btn"
        aria-label={t("settings.theme")}
        title={t("settings.theme")}
        onClick={onClick}
      >
        <span aria-hidden="true">{goingDark ? "🌙" : "☀️"}</span>
      </button>
    </div>
  );
}
